import { computed, inject, type Signal } from '@angular/core';
import { injectProtectedEntry } from '@sbe-spinoff-client/app-shell';
import type { Routes } from '@angular/router';
import { StaffOidcAuthService } from './staff-oidc-auth.service';

/**
 * `AppShellRootComponent`의 `showBootLoading` 입력에 그대로 바인딩하는 signal을 반환한다.
 * guard로 보호된 경로(`injectProtectedEntry`)로 콜드 진입/새로고침해 `staffAuthGuard`가
 * `loadMe()`(`GET /staff/auth/me`)를 기다리는 동안만 로딩 상태를 켠다. guard 없는
 * 경로(`/signed-out` 등)는 `sessionChecked()`가 영원히 안 바뀔 수 있으므로
 * `isProtectedEntry`로 먼저 걸러야 한다 — `sessionChecked()`만 보면 그 경로에서
 * 스피너가 영구히 멈춘다(`sbe-commerce/staff-web`에서 실측된 버그, 아래 원본 구현 참고).
 *
 * `sbe-commerce/staff-web`의 원본 hand-roll 구현(2026-08-11)을 lib으로 승격한다 —
 * 이 PR에서 그 앱의 hand-roll `PUBLIC_TOP_SEGMENTS`/`isProtectedEntry`/`.session-loading`
 * 마크업을 이 훅으로 실제 교체했다(Gemini 리뷰 지적, 2026-08-13 — 이전 문구는 교체가
 * 아직 안 된 것처럼 읽혔다).
 *
 * @param routes 앱의 최상위 `Routes` — `canActivate` 유무로 공개 경로를 유도한다
 *   (`injectProtectedEntry` 참고).
 */
export function injectStaffOidcBootLoading(routes: Routes): Signal<boolean> {
  const auth = inject(StaffOidcAuthService);
  const isProtectedEntry = injectProtectedEntry(routes);

  return computed(() => isProtectedEntry && !auth.sessionChecked());
}
